import { render, staticRenderFns } from "./InputCredit.vue?vue&type=template&id=0bb8c2a8&scoped=true"
import script from "./InputCredit.vue?vue&type=script&lang=js"
export * from "./InputCredit.vue?vue&type=script&lang=js"
import style0 from "./InputCredit.vue?vue&type=style&index=0&id=0bb8c2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8c2a8",
  null
  
)

export default component.exports